import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Alert,
  Container,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useMediaQuery,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import otpImage from "../../../../../components/varification_img.avif";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useAuth } from "../../../components/AuthContext";
import SendIcon from "@mui/icons-material/Send";
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
const genderOptions = ["Male", "Female"];
const maritalStatusOptions = ["Single", "Married"];
const bloodGroupOptions = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
const steps = ["Personal and Educational Information", "Employment Details"];
const OnboardingForm = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpVerified, setOtpVerified] = useState(false);
  const getOtp = () => otp.join("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormAlreadySubmitted, setIsFormAlreadySubmitted] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [jobData, setJobData] = useState(null);
  const [dialogMessage, setDialogMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:960px)");
  const isVerySmallScreen = useMediaQuery("(max-width:580px)");
  const isTabletOrBelow = useMediaQuery("(max-width:970px)");
  const { setOtpVerification, setEmail } = useAuth();
  const [progress, setProgress] = useState(0);
  const [website, setWebsite] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
const [isResendingOtp, setIsResendingOtp] = useState(false);
const [sendOtpProgress, setSendOtpProgress] = useState(0);
const [verifyOtpProgress, setVerifyOtpProgress] = useState(0);
const [resendOtpProgress, setResendOtpProgress] = useState(0);
const [dialogProgress, setDialogProgress] = useState(0);
const [showCheckmark, setShowCheckmark] = useState(false);
const [progressDialogStage, setProgressDialogStage] = useState("submitting"); // "submitting", "success", "error"
const [showIcon, setShowIcon] = useState(false);
  const [formData, setFormData] = useState({
    legalName: "",
    gender: "",
    dateOfBirth: "",
    photograph: null,
    maritalStatus: "",
    languagesKnown: "",
    presentAddress: "",
    permanentAddress: "",
    nativePlace: "",
    collegeName: "",
    universityName: "",
    yearOfPassing: "",
    keySkills: "",
    lastEmployerRelievingDate: "",
    lastEmployerRelievingLetter: null,
    lastEmployerExperienceLetter: null,
    aadharCard: null,
    panCard: null,
    emergencyContact1: "",
    relation1: "",
    emergencyContactNumber1: "",
    emergencyContact2: "",
    relation2: "",
    emergencyContactNumber2: "",
    familyContactNumber: "",
    bloodGroup: "",
  });
  const requiredFields = [
    "legalName",
    "gender",
    "dateOfBirth",
    "collegeName",
    "universityName",
    "yearOfPassing",
    "keySkills",
    "nativePlace",
    "emergencyContact1",
    "relation1",
    "emergencyContactNumber1",
  ];

  const requiredFieldsPerStep = {
    0: [
      "legalName",
      "gender",
      "dateOfBirth",
      "collegeName",
      "universityName",
      "yearOfPassing",
      "keySkills",
      "nativePlace",
    ],
    1: ["emergencyContact1", "relation1", "emergencyContactNumber1"],
  };

  const [filePreviews, setFilePreviews] = useState({});
  const [error, setError] = useState(null);

  const allowedFileTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;

    // Added useEffect for progress updates
    useEffect(() => {
      let sendInterval, verifyInterval, resendInterval, submitInterval;
    
      if (isSendingOtp) {
        sendInterval = setInterval(() => {
          setSendOtpProgress((prev) => {
            if (prev >= 100) return 100;
            return prev + 25;
          });
        }, 500);
      }
    
      if (isVerifyingOtp) {
        verifyInterval = setInterval(() => {
          setVerifyOtpProgress((prev) => {
            if (prev >= 100) return 100;
            return prev + 25;
          });
        }, 500);
      }
    
      if (isResendingOtp) {
        resendInterval = setInterval(() => {
          setResendOtpProgress((prev) => {
            if (prev >= 100) return 100;
            return prev + 25;
          });
        }, 500);
      }
    
      if (dialogOpen && progressDialogStage === "submitting") {
        submitInterval = setInterval(() => {
          setDialogProgress((prevProgress) => {
            if (prevProgress >= 90) return 90; // Keep at 90% until server responds
            return prevProgress + 10;
          });
        }, 200);
      } else if (dialogOpen && (progressDialogStage === "success" || progressDialogStage === "error")) {
        setDialogProgress(100);
        setTimeout(() => setShowIcon(true), 300);
      }
    
      return () => {
        clearInterval(sendInterval);
        clearInterval(verifyInterval);
        clearInterval(resendInterval);
        clearInterval(submitInterval);
      };
    }, [isSendingOtp, isVerifyingOtp, isResendingOtp, dialogOpen, progressDialogStage]);

useEffect(() => {
  const fetchConfig = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-config`);
      const data = await res.json();
      if (res.ok) {
        // setEmail(data.email || "");
        // setSendEmailUrl(data.sendEmailUrl || "");
        setWebsite(data.website || "");
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };
  fetchConfig();
}, []);
useEffect(() => {
  if (dialogOpen) {
    // Reset states when dialog opens
    setDialogProgress(0);
    setShowCheckmark(false);
    
    // Start progress animation
    const timer = setInterval(() => {
      setDialogProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          // Show checkmark after a small delay
          setTimeout(() => setShowCheckmark(true), 200);
          return 100;
        }
        return prevProgress + 2; // Increase by 2% every 50ms (will complete in 2.5 seconds)
      });
    }, 50);

    return () => clearInterval(timer);
  }
}, [dialogOpen]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/job_application/form/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const fetchedData = res.data;
        setJobData(res.data);
        if (fetchedData?.form_onbording_submitted === true) {
          setFormData((prev) => ({ ...prev, ...fetchedData }));
          setShowOtpScreen(false);
          setOtpVerified(true);
          setSubmitted(true);
          setIsFormAlreadySubmitted(true);
        } else {
          setIsFormAlreadySubmitted(false);
        }
      } catch (err) {
        setError("Failed to fetch form data");
      }
    };
    if (id) fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    if (type === "file") {
      const file = files[0];
      if (!file) return;
      if (!allowedFileTypes.includes(file.type)) {
        setError((prev) => ({ ...prev, [name]: "This file type is not allowed." }));
        return;
      }
      const fileURL = URL.createObjectURL(file);
      setFilePreviews((prev) => ({ ...prev, [name]: fileURL }));
      setFormData((prev) => ({ ...prev, [name]: file }));
      // Clear any existing error for this file field
      setError((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
      // Perform real-time validation for the changed field
      const errors = validateForm([name], { ...formData, [name]: value });
      setError((prev) => {
        const newErrors = { ...prev };
        if (Object.keys(errors).length === 0) {
          delete newErrors[name]; // Clear error if field is valid
        } else {
          newErrors[name] = errors[name]; // Set error if field is invalid
        }
        return newErrors;
      });
    }
  };
  useEffect(() => {
    // For each error, revalidate the related field
    const currentErrors = { ...error };
    let hasChange = false;
    Object.keys(currentErrors).forEach((field) => {
      const fieldErrors = validateForm([field], formData);
      if (!fieldErrors[field]) {
        delete currentErrors[field];
        hasChange = true;
      }
    });
    if (hasChange) {
      setError(currentErrors);
    }
  }, [formData]);

  const handleVerifyOtp = async () => {
    setIsVerifyingOtp(true);
    setVerifyOtpProgress(25);
    try {
      const otpValue = getOtp();
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/verify-otp`,
        {
          otp: otpValue,
          id,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
  
      if (res.data.status === "verified") {
        setOtpVerification(true);
        setOtpVerified(true);
        setShowOtpScreen(false);
        setError("");
        setSubmitted(res.data.submitted || false);
        setFormData(res.data.formData);
        setVerifyOtpProgress(100);
      } else {
        setError("Invalid OTP");
        setVerifyOtpProgress(0);
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setError("OTP verification failed");
      setVerifyOtpProgress(0);
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  useEffect(() => {
    if (id && !otpVerified && !submitted) {
      setShowOtpScreen(true);
    }
  }, [id, otpVerified, submitted]);

  const handleSendOtp = async () => {
    setIsSendingOtp(true);
    setSendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ id: id, status: "Onboarding" }),
        }
      );
  
      const data = await response.json();
  
      if (response.ok) {
        setIsOtpSent(true);
        setError("");
        setSendOtpProgress(100);
      } else {
        setError(data.message || "Failed to send OTP. Please try again.");
        setSendOtpProgress(0);
      }
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
      setSendOtpProgress(0);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    setIsResendingOtp(true);
    setResendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`,
        {
          id,
          is_resend: true,
          status: "Onboarding"
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
  
      if (response.status === 200) {
        setIsOtpSent(true);
        setOtp(["", "", "", "", "", ""]);
        setError("");
        // setDialogTitle("OTP Resent");
        setDialogMessage("OTP has been resent.");
        setDialogOpen(true);
        setResendOtpProgress(100);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP.");
      setResendOtpProgress(0);
    } finally {
      setIsResendingOtp(false);
    }
  };

  const handleDownload = (fileUrl) => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileUrl.split("/").pop();
    a.click();
  };
  const formatFieldName = (fieldName) => {
    return fieldName
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, str => str.toUpperCase())
      .trim();
  };
  const validateForm = (fieldsToCheck, data) => {
    const newErrors = {};
    const safeFormData = data || formData || {};
    const currentYear = new Date().getFullYear();
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(currentYear - 18);
    const fields = Array.isArray(fieldsToCheck)
      ? fieldsToCheck
      : Object.keys(safeFormData);
    if (!safeFormData || typeof safeFormData !== "object") {
      fields.forEach((field) => {
        newErrors[field] = `${formatFieldName(field)} is required`;
      });
      return newErrors;
    }
    fields.forEach((field) => {
      const value = safeFormData[field];
      if (
        field === "emergencyContact2" ||
        field === "relation2" ||
        field === "emergencyContactNumber2"
      ) {
        const v1 = (safeFormData["emergencyContact2"] || "").trim();
        const v2 = (safeFormData["relation2"] || "").trim();
        const v3 = (safeFormData["emergencyContactNumber2"] || "").toString().trim();
        const anyFilled = v1 || v2 || v3;
        if (anyFilled) {
          if (!v1 && field === "emergencyContact2") {
            newErrors[field] = "Emergency Contact Name 2 is required";
          }
          if (!v2 && field === "relation2") {
            newErrors[field] = "Relation 2 is required";
          } else if (
            field === "relation2" &&
            !/^[A-Za-z]+(?:[ _-][A-Za-z]+)*\s*$/.test(v2)
          ) {
            newErrors[field] = "Relation 2 is invalid";
          }
          if (!v3 && field === "emergencyContactNumber2") {
            newErrors[field] = "Emergency Contact Number 2 is required";
          } else if (
            field === "emergencyContactNumber2" &&
            !/^\d{10}$/.test(v3)
          ) {
            newErrors[field] = "Emergency Contact Number 2 must be 10 digits";
          } else if (
            field === "emergencyContactNumber2" &&
            /^(\d)\1{9}$/.test(v3)
          ) {
            newErrors[field] = "Emergency Contact Number 2 not valid";
          }
        }
        return; // Skip remaining validation for these 3
      }
      if (field === "familyContactNumber") {
        if (value && !/^\d{10}$/.test(value)) {
          newErrors[field] = "Family contact number must be 10 digits";
        }
        return;
      }
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        if (
          field === "emergencyContactNumber2" ||
          field === "familyContactNumber" ||
          field === "emergencyContact2" ||
          field === "relation2"
        ) {
          // Optional, handled separately
          return;
        }
        newErrors[field] = field === "emergencyContact1"
          ? "Emergency Contact Name 1 is required"
          : field === "emergencyContactNumber1"
          ? "Emergency Contact Number 1 is required"
          : field === "relation1"
          ? "Relation 1 is required"
          : `${formatFieldName(field)} is required`;
      } else {
        if (field === "legalName") {
          const trimmedValue = value?.trim() || "";
          if (/\d/.test(trimmedValue)) {
            newErrors[field] = "Legal name should not contain numbers";
          } else if (/[^a-zA-Z.\s]/.test(trimmedValue)) {
            newErrors[field] = "Legal name should not contain special characters";
          }
        }
        const textFieldValidationRegex =
          /^(?=.*[A-Za-z])[A-Za-z0-9\s,.'\-()&]+$/;
        if (field === "collegeName" && !textFieldValidationRegex.test(value)) {
          newErrors[field] =
            "College name must include letters and cannot be only numbers or special characters";
        }
        if (
          field === "universityName" &&
          !textFieldValidationRegex.test(value)
        ) {
          newErrors[field] =
            "University name must include letters and cannot be only numbers or special characters";
        }
        if (field === "yearOfPassing") {
          if (!/^\d{4}$/.test(value)) {
            newErrors[field] = "Year of passing must be a 4-digit number";
          } else if (parseInt(value, 10) > currentYear) {
            newErrors[field] = `Year of passing must be ${currentYear} or earlier.`;
          }
        }
        const keySkillsRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 .+/#-,]+$/;
        if (field === "keySkills" && !keySkillsRegex.test(value)) {
          newErrors[field] =
            "Key skills must include letters and may only contain letters, numbers, spaces, and . + / # - , characters.";
        }
        if (field === "nativePlace" && !textFieldValidationRegex.test(value)) {
          newErrors[field] =
            "Native place must include letters and cannot be only numbers or special characters";
        }
        if (field === "dateOfBirth") {
          const dob = new Date(value);
          if (dob > eighteenYearsAgo) {
            newErrors[field] = "You must be at least 18 years old.";
          }
        }
        if (field === "emergencyContact1") {
          if (!/^[A-Za-z\s]+$/.test(value)) {
            newErrors[field] =
              "Emergency Contact Name 1 must contain only letters and spaces";
          }
        }
        if (field === "relation1") {
          if (!/^[A-Za-z]+(?:[ _-][A-Za-z]+)*\s*$/.test(value)) {
            newErrors[field] = "Relation 1 is invalid";
          }
        }
        if (field === "emergencyContactNumber1") {
          if (!/^\d{10}$/.test(value)) {
            newErrors[field] =
              "Emergency Contact Number 1 must be exactly 10 digits";
          } else if (/^(\d)\1{9}$/.test(value)) {
            newErrors[field] = "Emergency Contact Number 1 not valid";
          }
        }
      }
    });
    return newErrors;
  };

  const handleSubmit = async () => {
    // Validate form first before showing any dialog
    const allRequiredFields = Object.values(requiredFieldsPerStep).flat();
    const conditionalFields = [
      "emergencyContact2",
      "relation2",
      "emergencyContactNumber2",
      "familyContactNumber",
    ];
    const fieldsToCheck = [...new Set([...allRequiredFields, ...conditionalFields])];
    const errors = validateForm(fieldsToCheck, formData);
    
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return; // Stop here - don't show dialog for validation errors
    }
  
    setError({});
  
    // Only show dialog if validation passes
    setIsSubmitting(true);
    setDialogOpen(true);
    setProgressDialogStage("submitting");
    setDialogProgress(0);
    setShowIcon(false);
    setDialogTitle("Submitting");
    setDialogMessage("Submitting your application...");
  
    try {
      const formPayload = new FormData();
      formPayload.append("id", id);
      formPayload.append("legalName", formData.legalName || "");
      formPayload.append("gender", formData.gender || "");
      formPayload.append("dateOfBirth", formData.dateOfBirth || "");
      formPayload.append("maritalStatus", formData.maritalStatus || "");
      formPayload.append("languagesKnown", formData.languagesKnown || "");
      formPayload.append("presentAddress", formData.presentAddress || "");
      formPayload.append("permanentAddress", formData.permanentAddress || "");
      formPayload.append("nativePlace", formData.nativePlace || "");
      formPayload.append("collegeName", formData.collegeName || "");
      formPayload.append("universityName", formData.universityName || "");
      formPayload.append("yearOfPassing", formData.yearOfPassing || "");
      formPayload.append("keySkills", formData.keySkills || "");
      formPayload.append(
        "lastEmployerRelievingDate",
        formData.lastEmployerRelievingDate || ""
      );
      formPayload.append("emergencyContact1", formData.emergencyContact1 || "");
      formPayload.append("relation1", formData.relation1 || "");
      formPayload.append(
        "emergencyContactNumber1",
        formData.emergencyContactNumber1 || ""
      );
      formPayload.append("emergencyContact2", formData.emergencyContact2 || "");
      formPayload.append("relation2", formData.relation2 || "");
      formPayload.append(
        "emergencyContactNumber2",
        formData.emergencyContactNumber2 || ""
      );
      formPayload.append(
        "familyContactNumber",
        formData.familyContactNumber || ""
      );
      formPayload.append("bloodGroup", formData.bloodGroup || "");
      formPayload.append("photograph", formData.photograph || "");
      formPayload.append(
        "lastEmployerRelievingLetter",
        formData.lastEmployerRelievingLetter || ""
      );
      formPayload.append(
        "lastEmployerExperienceLetter",
        formData.lastEmployerExperienceLetter || ""
      );
      formPayload.append("aadharCard", formData.aadharCard || "");
      formPayload.append("panCard", formData.panCard || "");
  
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/onboarding-form`,
        {
          method: "POST",
          body: formPayload,
        }
      );
  
      const result = await response.json().catch(() => response.text());
  
      if (response.ok) {
        setProgressDialogStage("success");
        setDialogTitle("Form Submitted Successfully"); // Changed from "Oh Yeah!"
        setDialogMessage("Thank you! Your onboarding form has  been submitted successfully.");
        setIsFormAlreadySubmitted(true);
        setSubmitted(true);
        setShowOtpScreen(false);
      } else {
        setProgressDialogStage("error");
        setDialogTitle("Something Went Wrong");
        setDialogMessage(
           "We couldn’t submit your onboarding form. Please refresh the page or try later."
        );
        setError({ general: result.error || "Submission failed" });
      }
    } catch (error) {
      console.error("Submission error:", error);
      setProgressDialogStage("error");
      setDialogTitle("Something Went Wrong");
      setDialogMessage("We couldn’t submit your onboarding form. Please refresh the page or try later.");
      setError({ general: "Network or server error" });
    } finally {
      setIsSubmitting(false); 
    }
  };
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // accept only digits
    const updatedOtp = [...otp];

    if (value.length === 1) {
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Move to next box if exists
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }

    // Handle paste of multiple digits
    if (value.length > 1) {
      for (let i = 0; i < value.length && index + i < otp.length; i++) {
        updatedOtp[index + i] = value[i];
      }
      setOtp(updatedOtp);

      const nextInput = document.querySelector(
        `input[name=otp-${index + value.length}]`
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];

      if (otp[index]) {
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
        const prevInput = document.querySelector(
          `input[name=otp-${index - 1}]`
        );
        if (prevInput) prevInput.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      const prevInput = document.querySelector(`input[name=otp-${index - 1}]`);
      if (prevInput) prevInput.focus();
    }

    if (e.key === "ArrowRight" && index < otp.length - 1) {
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleNext = () => {
    const fieldsForCurrentStep = requiredFieldsPerStep[activeStep] || [];

    const errors = validateForm(fieldsForCurrentStep);

    if (Object.keys(errors).length > 0) {
      setError(errors);
    } else {
      setError({});
      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => prev + 1);
      } else {
        handleSubmit();
      }
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const labelStyle = {
    fontFamily: "Lexend",
    lineHeight: "1.4375em",
    position: "relative",
    transformOrigin: "left top",
    fontWeight: 500,
    fontSize: { xs: "16px", sm: "18px" }, 
    color: "rgb(10, 10, 10)",
    marginBottom: "6px",
    display: "block",
    padding: 0,
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    transition:
      "color 200ms cubic-bezier(0, 0, 0.2, 1), transform 200ms cubic-bezier(0, 0, 0.2, 1), max-width 200ms cubic-bezier(0, 0, 0.2, 1)",
  };

   const inputPropsStyle = {
    sx: {
      width: "100%", // Add this
      borderRadius: "15px",
      backgroundColor: "transparent",
      color: "rgb(46, 43, 43)",

      "& .MuiOutlinedInput-root": {
        width: "100%", // Add this
        borderRadius: "15px",
        fontSize: "18px",
        fontFamily: "Lexend",
        fontWeight: 200,
        color: "rgb(46, 43, 43)",
        
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa",
        borderRadius: "15px",
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#3DA3C4 !important",
        borderWidth: "2px",
      },

      "& input": {
        width: "100%", // Add this to control input box
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& textarea": {
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& .MuiFormHelperText-root": {
        fontSize: "16px",
        fontFamily: "Lexend",
      },
    },
  };

  const commonButtonStyle = {
    borderRadius: "50px",
    border: "2px solid #0087B4",
    color: "#0087B4",
    padding: "14px 28px",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    textTransform: "none",
    backgroundColor: "#FFFFFFD9",
    fontFamily: "Lexend",
    minWidth: "180px",
    height: "55px",
    "&:hover": {
      backgroundColor: "#0087B4",
      color: "#FFFFFFD9",
    },
  };

  if (showOtpScreen) {
    return (
      <Box
        sx={{
          mt: { xs: 8, md: 8 },
          display: "flex",
          flexDirection: "row",
          "@media (max-width: 1105px)": {
            flexDirection: "column",
          },
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 4, md: 6, lg: 12 },
          py: { xs: 4, md: 8 },
          gap: { xs: 4, md: 6 },
          width: "100%",
          maxWidth: "100vw",
          minHeight: "87vh",
          boxSizing: "border-box",
          overflow: "hidden",
          position: "relative",
          textAlign: "left",
          "@media (max-width:1105px)": {
            flexDirection: "column",
            alignItems: "center",
          },
        }}
      >
          {(isSendingOtp || isVerifyingOtp || isResendingOtp) && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1300,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            padding: 4,
            borderRadius: 2,
          }}
        >
          <CircularProgress
            variant="determinate"
            value={
              isSendingOtp
                ? sendOtpProgress
                : isVerifyingOtp
                ? verifyOtpProgress
                : resendOtpProgress
            }
            size={60}
            thickness={4}
            sx={{ color: "#0087B4" }}
          />
          <Typography sx={{ mt: 2, color: "#333", fontFamily: "Lexend", fontSize: "18px" }}>
            {isSendingOtp
              ? "Sending OTP..."
              : isVerifyingOtp
              ? "Verifying OTP..."
              : "Resending OTP..."}
          </Typography>
        </Box>
      </Box>
    )}
        <Box
          sx={{
            order: 1,
            width: { xs: "100%", md: "45%", lg: "40%" },
            maxWidth: { xs: "700px", md: "600px" },
            mb: { xs: 4, md: 0 },
            textAlign: "center",
            flexShrink: 0,
            "& img": {
              width: "100%",
              height: "auto",
              maxWidth: { xs: "700px", md: "100%" },
              objectFit: "contain",
            },
            "@media (max-width: 1105px)": {
              order: -1,
              width: "100%",
              maxWidth: "700px",
              mb: 4,
            },
          }}
        >
          <img
            src={otpImage}
            alt="OTP Illustration"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
              borderRadius: "15px",
            }}
          />
        </Box>

        {/* Content Section */}
        <Box
          sx={{
            order: 0,
            width: { xs: "100%", md: "55%", lg: "50%" },
            maxWidth: "600px",
            px: { xs: 1, sm: 2 },
            textAlign: "left",
            transform: {
              xs: "translateX(0)",
              sm: "translateX(-1%)",
              md: "translateX(-2%)",
              lg: "translateX(-4%)",
              xl: "translateX(0%)",
            },
            transition: "transform 0.3s ease",
            "@media (max-width:1105px)": {
              order: 0,
              width: "100%",
              maxWidth: "700px",
            },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "36px", sm: "38px", md: "40px", lg: "40px" },
              fontWeight: "500",
              mb: 2,
              textAlign: "left",
              fontFamily: "Lexend",
              color: "#000000DE",
            }}
          >
            Welcome, {jobData?.name} - Complete OTP Verification to proceed
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
             
              {error}
            </Alert>
          )}

          {!isOtpSent ? (
            <>
              <Typography
                sx={{
                  fontSize: "16px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#555555",
                }}
              >
                Click "Send OTP" to receive a verification code on your email.
              </Typography>
              <Button
                variant="contained"
                onClick={handleSendOtp}
                sx={{
                  mt: 2,
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none",
                  },
                }}
              >
                Send OTP
              </Button>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "18px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#000000DE",
                }}
              >
                Please enter the 6-digit OTP sent to your email
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    name={`otp-${index}`}
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "18px",
                        padding: 0,
                        fontFamily: "Lexend",
                        color: "#000000DE",
                      },
                    }}
                    sx={{
                      width: "61px",
                      height: "50px",
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                      borderRadius: "15px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "15px",
                        height: "100%",
                      },
                    }}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                onClick={handleVerifyOtp}
                sx={{
                  mb: 2,
                  width: "170px",
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none", 
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none", 
                  },
                }}
              >
                Verify OTP
              </Button>

              <Box>
                <Button
                  onClick={handleResendOtp}
                  sx={{
                    mt: 1,
                    color: "#0087B4",
                    padding: 0,
                    pl:3,
                    fontSize: "18px",
                    fontWeight: 380,
                    textTransform: "none",
                    backgroundColor: "transparent",
                    minWidth: "auto",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                    },
                    "&:focus": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  Resend OTP
                </Button>
              </Box>

              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                PaperProps={{
                  sx: {
                    width: 450,
                    maxWidth: "90vw",
                    padding: 2,
                    fontSize: "18px",
                    fontFamily: "Lexend",
                    color: "#000000DE",
                    borderRadius: "19px",
                  },
                }}
              >
                <DialogTitle sx={{ fontFamily: "Lexend", fontWeight:400}}>{dialogTitle}</DialogTitle>
                <DialogContent>
                  <Typography sx={{  fontFamily: "Lexend", fontWeight:300, color:'#000000DE'}}>{dialogMessage}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setDialogOpen(false)} sx={{ fontFamily: "Lexend", color:'#0087B4'}}>OK</Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        </Box>
      </Box>
    );
  }
  return (
    <Box
      sx={{
        width: "100%",
        mt: { xs: "80px", md: "120px" },
        boxSizing: "border-box",
        overflowX: "hidden",
        position:"relative"
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1480px",
          mx: "auto",
          boxSizing: "border-box",
          paddingLeft: { xs: "12px", sm: "24px", md: "32px" },
          paddingRight: { xs: "12px", sm: "24px", md: "32px" },
          "@media (min-width:900px)": {
            paddingLeft: "125px",
            paddingRight: "85px",
          },
        }}
      >
        <Grid
          container
          spacing={2}
          direction={isSmallScreen ? "column" : "row"}
          alignItems={isSmallScreen ? "center" : "flex-start"}
        >
          {/* Stepper */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              mb: isSmallScreen ? 3 : 0,
              mt: isSmallScreen ? 2 : 0,
              pl: isSmallScreen ? 1 : 0,
              pt: 5.75,
              display: isVerySmallScreen ? "flex" : "block",
              justifyContent: isVerySmallScreen ? "center" : "flex-start",
              "@media (max-width:900px)": {
                mt: "36px",
              },
            }}
          >
            <Stepper
              activeStep={activeStep}
              orientation={isSmallScreen ? "horizontal" : "vertical"}
              alternativeLabel={isSmallScreen}
              sx={{
                width: "100%",
                justifyContent: isSmallScreen ? "center" : "flex-start",
                "& .MuiStepIcon-root": {
                  color: "#0087B4",
                  fontSize: "1.95rem", 
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "#0087B4",
                  fontSize: "1.95rem", 
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "#0087B4",
                  fontSize: "1.95rem",
                },
                "& .MuiStepConnector-line": {
                  borderColor: "#00002D",
                },
              }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontSize: "18px",
                        fontFamily: "Lexend",
                        color: "#000000DE",
                        
                        textAlign: isSmallScreen ? "center" : "inherit",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid
            item
            xs={12}
            md={9}
            sx={{ borderRadius: "15px", mt: { md: "6px" } , pt: 6}}
          >
            <Box
              sx={{
                "& .MuiInputBase-root": {
                  fontSize: "18px",
                  fontFamily: "Lexend",
                  color: "#000000DE",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "18px",
                  fontFamily: "Lexend",
                  color: "#000000DE",
                },
                "& .MuiFormHelperText-root": {
                  fontSize: "16px",
                  fontFamily: "Lexend",
                },
              }}
            >
              {activeStep === 0 && (
                <>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontWeight: "500",
                      fontSize: "28px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                    }}
                  >
                    Personal and Educational Information
                  </Typography>
                  {isFormAlreadySubmitted && (
                    <Alert
                      severity="success"
                      sx={{
                        mt: 4,
                        mb: 4,
                        backgroundColor: colors.primary,
                        fontSize: "18px",
                        fontFamily: "Lexend",
                        color: "#000000DE",
                      }}
                    >
                      Form has already been submitted.
                    </Alert>
                  )}
                  <Grid container spacing={2} sx={{ mt: 4 }}>
                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        Legal Name
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        name="legalName"
                        value={formData?.legalName || ""}
                        placeholder="Enter your full legal name"
                        onChange={handleChange}
                        // InputProps={{
                        //   readOnly: isFormAlreadySubmitted,
                        // }}
                        disabled={isFormAlreadySubmitted}
                        sx={inputPropsStyle.sx}
                        error={!!error?.legalName}
                        helperText={error?.legalName}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        Gender
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        select
                        required
                        name="gender"
                        value={formData?.gender || ""}
                        onChange={handleChange}
                        disabled={isFormAlreadySubmitted}
                        SelectProps={{
                          displayEmpty: true, 
                        }}
                        error={!!error?.gender}
                        helperText={error?.gender}
                        sx={{
                          ...inputPropsStyle.sx,
                          "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                          },
                        }}
                      >
                        {/* Placeholder that shows in textbox */}
                        <MenuItem value="" disabled>
                          <span style={{ color: "#9e9e9e" }}>
                            Select gender
                          </span>
                        </MenuItem>

                        {/* Actual options */}
                        {genderOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Grid
                        item
                        xs={12}
                        sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                      >
                        <Typography sx={labelStyle}>
                          Date of Birth
                          <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                            *
                          </Box>
                        </Typography>
                        <DatePicker
                          disabled={isFormAlreadySubmitted}
                          value={
                            formData?.dateOfBirth
                              ? dayjs(formData.dateOfBirth)
                              : null
                          }
                          onChange={(newValue) => {
                            setFormData((prev) => ({
                              ...prev,
                              dateOfBirth: newValue
                                ? dayjs(newValue).format("YYYY-MM-DD")
                                : "",
                            }));
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              error: !!error?.dateOfBirth,
                              helperText: error?.dateOfBirth,
                              InputProps: {
                                readOnly: isFormAlreadySubmitted,
                              },
                            },
                          }}
                          sx={inputPropsStyle.sx}
                        />
                      </Grid>
                    </LocalizationProvider>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>Photograph</Typography>
                      <TextField
  fullWidth
  type="file"
  name="photograph"
  onChange={handleChange}
  disabled={isFormAlreadySubmitted}
  inputProps={{
    placeholder: "Upload your photograph",
    accept: "image/jpeg,image/png",
  }}
  InputLabelProps={{ shrink: true }}
  InputProps={{
    endAdornment: formData?.photograph ? (
      <InputAdornment position="end">
        <IconButton
          onClick={() =>
            handleDownload(
              filePreviews?.photograph || formData?.photograph
            )
          }
        >
          <VisibilityIcon />
        </IconButton>
      </InputAdornment>
    ) : null,
  }}
  helperText="Only JPEG or PNG format is allowed"
  sx={inputPropsStyle.sx}
/>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>Marital Status</Typography>
                      <TextField
                        fullWidth
                        select
                        name="maritalStatus"
                        value={formData?.maritalStatus || ""}
                        onChange={handleChange}
                        disabled={isFormAlreadySubmitted}
                        SelectProps={{
                          displayEmpty: true, // 🔑 Required to show placeholder in input
                        }}
                        sx={inputPropsStyle.sx}
                      >
                        {/* Placeholder */}
                        <MenuItem value="" disabled>
                          <span style={{ color: "#9e9e9e" }}>
                            Select marital status
                          </span>
                        </MenuItem>

                        {/* Options */}
                        {maritalStatusOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>Languages Known</Typography>
                      <TextField
                        fullWidth
                        name="languagesKnown"
                        placeholder="List languages you know"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.languagesKnown || ""}
                        onChange={handleChange}
                        sx={inputPropsStyle.sx}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>Present Address</Typography>
                      <TextField
                        fullWidth
                        multiline
                        name="presentAddress"
                        placeholder="Enter your present address"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.presentAddress || ""}
                        onChange={handleChange}
                        sx={{
                          ...inputPropsStyle.sx,
                          "& .MuiInputBase-input": {
                            paddingLeft: "9px", 
                            color: "#000",
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>Permanent Address</Typography>
                      <TextField
                        fullWidth
                        multiline
                        name="permanentAddress"
                        placeholder="Enter your permanent address"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.permanentAddress || ""}
                        onChange={handleChange}
                        sx={{
                          ...inputPropsStyle.sx,
                          "& .MuiInputBase-input": {
                            paddingLeft: "9px", 
                            color: "#000",
                          },
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        Native Place
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        name="nativePlace"
                        placeholder="Enter your native place"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.nativePlace || ""}
                        onChange={handleChange}
                        sx={inputPropsStyle.sx}
                        error={!!error?.nativePlace}
                        helperText={error?.nativePlace}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        College Name
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        name="collegeName"
                        placeholder="Enter your college name"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.collegeName || ""}
                        onChange={handleChange}
                        sx={inputPropsStyle.sx}
                        error={!!error?.collegeName}
                        helperText={error?.collegeName}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        University Name
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        name="universityName"
                        placeholder="Enter your university name"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.universityName || ""}
                        onChange={handleChange}
                        sx={inputPropsStyle.sx}
                        error={!!error?.universityName}
                        helperText={error?.universityName}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                    >
                      <Typography sx={labelStyle}>
                        Year of Passing
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        name="yearOfPassing"
                        placeholder="Enter the year of passing"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.yearOfPassing || ""}
                        onChange={handleChange}
                        sx={inputPropsStyle.sx}
                        error={!!error?.yearOfPassing}
                        helperText={error?.yearOfPassing}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography sx={labelStyle}>
                        Key Skills
                        <Box component="span" sx={{ color: "red", ml: 0.5 }}>
                          *
                        </Box>
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        name="keySkills"
                        placeholder="Enter key skills (comma-separated)"
                        InputProps={{
                          readOnly: isFormAlreadySubmitted,
                        }}
                        disabled={isFormAlreadySubmitted}
                        value={formData?.keySkills || ""}
                        onChange={handleChange}
                        sx={{
                          ...inputPropsStyle.sx,
                          "& .MuiInputBase-input": {
                            paddingLeft: "3px", 
                          },
                        }}
                        error={!!error?.keySkills}
                        helperText={error?.keySkills}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

{activeStep === 1 && (
    <>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "500",
          fontSize: "28px",
          fontFamily: "Lexend",
          color: "rgba(0, 0, 0, 0.87)",
        }}
      >
        Employment Details
      </Typography>

      {isFormAlreadySubmitted && (
        <Alert
          severity="success"
          sx={{
            mt: 4,
            mb: 4,
            backgroundColor: colors.primary,
            fontSize: "18px",
            fontFamily: "Lexend",
            color: "rgba(0, 0, 0, 0.87)",
          }}
        >
          Form has already been submitted.
        </Alert>
      )}

      <Grid container spacing={2} sx={{ mt: 4 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid item xs={12}>
            <Typography sx={labelStyle}>
              Latest Employer Relieving Date
            </Typography>
            <DatePicker
              disabled={isFormAlreadySubmitted}
              value={
                formData?.lastEmployerRelievingDate
                  ? dayjs(formData.lastEmployerRelievingDate)
                  : null
              }
              onChange={(newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  lastEmployerRelievingDate: newValue
                    ? dayjs(newValue).format("YYYY-MM-DD")
                    : "",
                }));
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  placeholder: "Select relieving date",
                  InputProps: {
                    readOnly: isFormAlreadySubmitted,
                  },
                },
              }}
              sx={inputPropsStyle.sx}
            />
          </Grid>
        </LocalizationProvider>

        {[
          {
            label: "Relieving Letter",
            name: "lastEmployerRelievingLetter",
          },
          {
            label: "Experience Letter",
            name: "lastEmployerExperienceLetter",
          },
          { label: "Aadhar Card", name: "aadharCard" },
          { label: "PAN Card", name: "panCard" },
        ].map(({ label, name }) => (
          <Grid item xs={12} key={name}>
            <Typography sx={labelStyle}>{label}</Typography>
            <TextField
              fullWidth
              type="file"
              name={name}
              onChange={handleChange}
              inputProps={{
                placeholder: `Upload ${label.toLowerCase()}`,
                accept:
                  "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png",
              }}
              InputLabelProps={{ shrink: true }}
              disabled={isFormAlreadySubmitted}
              InputProps={{
                endAdornment: formData?.[name] ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        handleDownload(
                          filePreviews?.[name] || formData?.[name]
                        )
                      }
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
              sx={inputPropsStyle.sx}
              helperText="Allowed formats: PDF, DOC, DOCX, JPEG, PNG"
            />
          </Grid>
        ))}

        {[
          {
            label: "Emergency Contact Name 1",
            name: "emergencyContact1",
            required: true,
          },
          { label: "Relation 1", name: "relation1", required: true },
          {
            label: "Emergency Contact Number 1",
            name: "emergencyContactNumber1",
            required: true,
          },
          { label: "Emergency Contact Name 2", name: "emergencyContact2" },
          { label: "Relation 2", name: "relation2" },
          {
            label: "Emergency Contact Number 2",
            name: "emergencyContactNumber2",
          },
          {
            label: "Family Contact Number",
            name: "familyContactNumber",
          },
        ].map(({ label, name, required }) => {
          const isHalfWidthField = [
            "relation1",
            "relation2",
            "emergencyContactNumber1",
            "emergencyContactNumber2",
            "familyContactNumber",
          ].includes(name);

          return (
            <Grid
              item
              xs={12}
              sm={
                isHalfWidthField &&
                !(isTabletOrBelow || isVerySmallScreen)
                  ? 6
                  : 12
              }
              key={name}
            >
              <Typography sx={labelStyle}>
                {label}
                {required && (
                  <Box
                    component="span"
                    sx={{ color: "red", ml: 0.5 }}
                  >
                    *
                  </Box>
                )}
              </Typography>
              <TextField
                fullWidth
                name={name}
                placeholder={`Enter ${label.toLowerCase()}`}
                value={formData?.[name] || ""}
                onChange={handleChange}
                InputProps={{ readOnly: isFormAlreadySubmitted }}
                disabled={isFormAlreadySubmitted}
                sx={inputPropsStyle.sx}
                error={!!error?.[name]}
                helperText={error?.[name]}
              />
            </Grid>
          );
        })}

        <Grid
          item
          xs={12}
          sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
        >
          <Typography sx={labelStyle}>Blood Group</Typography>
          <TextField
            fullWidth
            select
            name="bloodGroup"
            value={formData?.bloodGroup || ""}
            onChange={handleChange}
            disabled={isFormAlreadySubmitted}
            SelectProps={{
              displayEmpty: true,
            }}
            sx={inputPropsStyle.sx}
          >
            <MenuItem value="" disabled>
              <span style={{ color: "#9e9e9e" }}>
                Select blood group
              </span>
            </MenuItem>
            {bloodGroupOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </>
  )}
              <Box
                sx={{
                  mt: 4,
                  pb: 4,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 3,
                  borderRadius: "15px",
                  flexWrap: "wrap",
                }}
              >
                {activeStep > 0 && (
                  <Button
                    onClick={handleBack}
                    variant="outlined"
                    sx={commonButtonStyle}
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                )}

                {activeStep === steps.length - 1 ? (
                  !isFormAlreadySubmitted && (
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                      sx={commonButtonStyle}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  )
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    sx={commonButtonStyle}
                    endIcon={<ArrowForwardIcon />}
                  >
                    Continue
                  </Button>
                )}
              </Box>
              <Dialog
  open={dialogOpen}
  onClose={progressDialogStage !== "submitting" ? () => setDialogOpen(false) : undefined}
  disableEscapeKeyDown={progressDialogStage === "submitting"}
  PaperProps={{
    sx: {
      width: 450,
      maxWidth: "90vw",
      padding: 2,
      fontSize: "18px",
      fontFamily: "Lexend",
      color: "#000000DE",
      borderRadius: "19px",
    },
  }}
>
  <DialogContent>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 3,
        mt: 2,
        position: "relative",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={dialogProgress}
        size={80}
        thickness={2}
        sx={{
          color: progressDialogStage === "error" ? "#f44336" : "#0087B4",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 80,
          opacity: showIcon ? 1 : 0,
          transform: showIcon ? "scale(1)" : "scale(0)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {progressDialogStage === "success" && (
          <CheckIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#0087B4",
            }}
          />
        )}
        {progressDialogStage === "error" && (
          <PriorityHighIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#f44336",
            }}
          />
        )}
      </Box>
    </Box>

    {progressDialogStage === "submitting" && (
      <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontSize: "18px", fontWeight: 400 }}>
        Submitting Application...
      </Typography>
    )}

    {(progressDialogStage === "success" || progressDialogStage === "error") && (
      <>
        <DialogTitle sx={{ textAlign: "center", fontSize: "20px", fontFamily: "Lexend", fontWeight: "bold", pb: 1 }}>
          {dialogTitle}
        </DialogTitle>
        <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontWeight:300, fontSize: "16px" }}>
          {dialogMessage}
        </Typography>
      </>
    )}
  </DialogContent>

  {progressDialogStage !== "submitting" && (
    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
      <Button
        onClick={() => {
          setDialogOpen(false);
          if (progressDialogStage === "success" && website) {
            window.location.href = website;
          }
        }}
        variant="contained"
        sx={{
          backgroundColor: "#0087B4",
          "&:hover": {
            backgroundColor: "#006e96",
          },
          borderRadius: "8px",
          px: 4,
          py: 1,
          fontSize: "16px",
          fontFamily: "Lexend",
        }}
      >
        OK
      </Button>
    </DialogActions>
  )}
</Dialog>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default OnboardingForm;